import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postSubmitContractMaintenanceEndpoint } from '../../../common/endpoints';

export const postSubmitContractMaintenance = createApi(postSubmitContractMaintenanceEndpoint, 'POST');

const SubmitContractMaintenance = createSlice({
  name: 'SubmitContractMaintenance',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSubmitContractMaintenance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSubmitContractMaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSubmitContractMaintenance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SubmitContractMaintenance.reducer;